import { customAlphabet } from 'nanoid'

// https://tools.ietf.org/id/draft-msporny-base58-01.html
const base58Alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
const nanoid = customAlphabet(base58Alphabet, 22)

type Prefix = 'proj' // project

export function friendlyID(prefix: Prefix, size?: number | undefined): string {
  return `${prefix}_${nanoid(size)}`
}
